import { render, staticRenderFns } from "./InfoScreen.vue?vue&type=template&id=4bfdf3c4&"
import script from "./InfoScreen.vue?vue&type=script&lang=js&"
export * from "./InfoScreen.vue?vue&type=script&lang=js&"
import style0 from "./InfoScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports